/**
 * guide-tour.js — BotaReco 使い方ガイドツアー汎用エンジン
 *
 * ライブラリ非依存のvanilla JS。window.scrollTo()のPromise対応を使い、
 * 対象要素までスクロール→ハイライト→説明ポップオーバー表示→「次へ」を
 * 繰り返す。Promise未対応ブラウザは固定ディレイでフォールバックする。
 *
 * ハイライトは「対象要素自体のz-indexを一時的に上げて暗転オーバーレイの上に
 * 出す」方式（box-shadowのスポットライト方式は環境によって効かないことがある
 * ため不採用）。
 *
 * 使い方:
 *   window.GuideTour.start('leaflabot_app', [
 *     { selector: '#consultation-form', title: '...', body: '...' },
 *     { selector: '#follow-up-modal .foo', title: '...', body: '...',
 *       onEnter: function(){ document.querySelector('...').click(); } },
 *   ]);
 *
 *   window.GuideTour.isSeen('leaflabot_app').then(function(seen){
 *     if (!seen) window.GuideTour.start('leaflabot_app', STEPS);
 *   });
 *
 * 既読管理はログイン済みユーザーのみSupabase(user_profiles.feature_tours_seen)
 * で行う。未ログイン時はisSeen()は常にfalseを返すが、自動起動するかどうかは
 * 呼び出し側の責任（未ログイン時は自動起動せず「使い方」ボタンからのみ起動する運用）。
 */
(function () {
  if (window.GuideTour) return;

  var STYLE_ID = 'gtour-style';
  var CSS = '' +
    // 暗転背景(z-index低)→ハイライト対象(z-index中)→ポップオーバー(z-index最高)の順に
    // 必ず重なるよう、暗転背景とポップオーバーを別要素に分離する(同じ要素の子同士だと
    // 対象要素のz-indexがポップオーバーより高い場合に対象が前面に出てしまうため)
    '.gtour-dim{position:fixed;inset:0;z-index:99980;background:rgba(17,17,17,.6);display:none;pointer-events:none;}' +
    '.gtour-target-active{z-index:99985;outline:3px solid #ffd400;outline-offset:3px;border-radius:8px;box-shadow:0 0 24px rgba(0,0,0,.35);}' +
    '.gtour-popover{position:fixed;z-index:99990;width:300px;max-width:88vw;background:#fff;border:2px solid #111;border-radius:16px;box-shadow:0 12px 0 rgba(0,0,0,.08);padding:16px;box-sizing:border-box;display:none;}' +
    '.gtour-popover-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;}' +
    '.gtour-step-count{font-size:11px;color:#888;font-weight:700;letter-spacing:.05em;}' +
    '.gtour-close{border:none;background:none;font-size:18px;color:#888;cursor:pointer;line-height:1;padding:0;}' +
    '.gtour-title{font-weight:800;font-size:15px;margin-bottom:6px;color:#0E0E0E;}' +
    '.gtour-body{font-size:13px;color:#333;line-height:1.6;margin-bottom:14px;white-space:pre-wrap;}' +
    '.gtour-actions{display:flex;justify-content:flex-end;gap:8px;}' +
    '.gtour-btn{border:2px solid #111;border-radius:20px;padding:8px 18px;font-size:12px;font-weight:700;cursor:pointer;background:#fff;color:#111;}' +
    '.gtour-btn-next{background:#111;color:#fff;}' +
    '@media (max-width:480px){.gtour-popover{width:calc(100vw - 32px);}}';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function apiCall(action, body) {
    var cfg = window.SUPABASE_CONFIG || {};
    if (!cfg.url || !cfg.key) return Promise.reject(new Error('SUPABASE_CONFIG not available'));
    return fetch(cfg.url + '/functions/v1/process-consultation?action=' + action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + cfg.key },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function getUserEmail() {
    return (window.LEAFLA && window.LEAFLA.customer && window.LEAFLA.customer.email) || null;
  }

  // 未ログイン時の既読管理はSupabase(user_profiles)に書けない(会員専用テーブルのため)。
  // leaflabot-app.jsのgetAnonymousId()と同じlocalStorageキーで匿名IDと同じスコープに
  // 揃え、ブラウザ内だけで完結する既読フラグを使う(サーバー往復不要で高速)。
  var LOCAL_SEEN_PREFIX = 'gtour_local_seen_';
  function isSeenLocal(tourId) {
    try { return localStorage.getItem(LOCAL_SEEN_PREFIX + tourId) === '1'; } catch (e) { return false; }
  }
  function markSeenLocal(tourId) {
    try { localStorage.setItem(LOCAL_SEEN_PREFIX + tourId, '1'); } catch (e) {}
  }

  // window.scrollTo()のPromise対応を使い、未対応ブラウザは固定ディレイでフォールバック
  function scrollToAsync(top) {
    try {
      var ret = window.scrollTo({ behavior: 'smooth', top: top });
      if (ret && typeof ret.then === 'function') return ret.catch(function () {});
    } catch (e) {}
    window.scrollTo({ behavior: 'smooth', top: top });
    return new Promise(function (resolve) { setTimeout(resolve, 500); });
  }

  var state = { steps: [], index: 0, tourId: null, dimEl: null, popoverEl: null, highlightedEl: null };

  function ensureOverlay() {
    if (state.popoverEl) return;
    ensureStyle();

    var dim = document.createElement('div');
    dim.className = 'gtour-dim';
    document.body.appendChild(dim);
    state.dimEl = dim;

    var pop = document.createElement('div');
    pop.className = 'gtour-popover';
    pop.innerHTML =
      '<div class="gtour-popover-head"><span class="gtour-step-count"></span><button class="gtour-close" aria-label="閉じる">×</button></div>' +
      '<div class="gtour-title"></div>' +
      '<div class="gtour-body"></div>' +
      '<div class="gtour-actions">' +
        '<button class="gtour-btn gtour-btn-skip">スキップ</button>' +
        '<button class="gtour-btn gtour-btn-next">次へ</button>' +
      '</div>';
    document.body.appendChild(pop);
    pop.querySelector('.gtour-close').onclick = finish;
    pop.querySelector('.gtour-btn-skip').onclick = finish;
    state.popoverEl = pop;
  }

  function clearHighlight() {
    if (state.highlightedEl) {
      state.highlightedEl.classList.remove('gtour-target-active');
      if (state.highlightedEl.getAttribute('data-gtour-pos-override')) {
        state.highlightedEl.style.position = '';
        state.highlightedEl.removeAttribute('data-gtour-pos-override');
      }
    }
    state.highlightedEl = null;
  }

  function applyHighlight(target) {
    clearHighlight();
    // z-indexで暗転オーバーレイより前面に出すにはposition:staticのままだと効かないため、
    // 元がstaticの場合のみreativeに上書きする（既存のposition指定は壊さない）
    if (getComputedStyle(target).position === 'static') {
      target.style.position = 'relative';
      target.setAttribute('data-gtour-pos-override', '1');
    }
    target.classList.add('gtour-target-active');
    state.highlightedEl = target;
  }

  // getBoundingClientRect()はビューポート基準の座標を返すため、ポップオーバーも
  // position:fixed(常にビューポート基準)に統一する。position:absoluteだと
  // ドキュメント基準になりスクロール量だけ位置がズレてしまうため使わない。
  // 横位置は対象のrect.left基準ではなく常に画面中央固定にする(狭いスマホ画面で
  // 対象が右寄りの場合に画面外へはみ出るのを防ぐため)。
  function positionPopover(target) {
    var pop = state.popoverEl;
    var rect = target.getBoundingClientRect();
    pop.style.left = '50%';
    pop.style.transform = 'translateX(-50%)';

    // 対象がビューポートより大きい場合、rect基準で上下に置く場所がなくハイライトと
    // 重なってしまうため、画面上部に固定表示する(下部は固定CTA等と衝突しやすいため)
    if (rect.height > window.innerHeight * 0.8) {
      pop.style.bottom = 'auto';
      pop.style.top = '16px';
      return;
    }

    pop.style.bottom = 'auto';
    var popTop = rect.bottom + 16;
    if (popTop + 220 > window.innerHeight) popTop = Math.max(16, rect.top - 220);
    pop.style.top = popTop + 'px';
  }

  function repositionCurrentStep() {
    if (state.highlightedEl && state.popoverEl && state.popoverEl.style.display === 'block') {
      positionPopover(state.highlightedEl);
    }
  }
  window.addEventListener('scroll', repositionCurrentStep, { passive: true });
  window.addEventListener('resize', repositionCurrentStep);

  function runStep(i) {
    var step = state.steps[i];
    if (!step) { finish(); return; }
    if (step.onEnter) { try { step.onEnter(); } catch (e) {} }

    setTimeout(function () {
      var target = step.selector ? document.querySelector(step.selector) : null;
      // セレクタ指定があるのに対象が見つからない場合(表示条件次第のタブ等)は
      // 浮いたポップオーバーを出さず次のステップへ自動的にスキップする
      if (step.selector && !target) {
        runStep(i + 1);
        return;
      }
      ensureOverlay();
      state.dimEl.style.display = 'block';
      state.popoverEl.style.display = 'block';

      var afterScroll = function () {
        if (target) {
          applyHighlight(target);
          positionPopover(target);
        } else {
          clearHighlight();
        }
        var pop = state.popoverEl;
        pop.querySelector('.gtour-step-count').textContent = (i + 1) + ' / ' + state.steps.length;
        pop.querySelector('.gtour-title').textContent = step.title || '';
        pop.querySelector('.gtour-body').textContent = step.body || '';
        var nextBtn = pop.querySelector('.gtour-btn-next');
        nextBtn.textContent = (i === state.steps.length - 1) ? '完了' : '次へ';
        nextBtn.onclick = function () {
          if (step.onExit) { try { step.onExit(); } catch (e) {} }
          state.index = i + 1;
          runStep(state.index);
        };
      };

      if (target) {
        var rect = target.getBoundingClientRect();
        var absoluteTop = rect.top + window.pageYOffset;
        var viewportH = window.innerHeight;
        // 要素がビューポートより大きい(長いリスト等)場合は中央寄せせず上端に少し余白を付けて表示する。
        // 中央寄せの計算は要素の高さ分ずれ込むため、長い要素だと途中の位置までスクロールされてしまう。
        // さらに、ポップオーバーを画面上部に固定表示するため、対象の上端がポップオーバーの
        // 高さ分だけ隠れないよう余白を多めに確保する。
        var targetScrollY = (rect.height > viewportH * 0.8)
          ? Math.max(0, absoluteTop - 210)
          : Math.max(0, absoluteTop - (viewportH / 2) + (rect.height / 2));
        scrollToAsync(targetScrollY).then(afterScroll);
      } else {
        afterScroll();
      }
    }, step.onEnter ? 250 : 0); // モーダルを開く等onEnterのアニメーション待ち
  }

  function finish() {
    clearHighlight();
    if (state.dimEl) state.dimEl.style.display = 'none';
    if (state.popoverEl) state.popoverEl.style.display = 'none';
    scrollToAsync(0);
    if (state.tourId) {
      var email = getUserEmail();
      if (email) {
        apiCall('mark_feature_tour_seen', { user_email: email, tour_id: state.tourId }).catch(function () {});
      } else {
        markSeenLocal(state.tourId);
      }
    }
  }

  window.GuideTour = {
    start: function (tourId, steps) {
      state.tourId = tourId;
      state.steps = steps || [];
      state.index = 0;
      runStep(0);
    },
    isSeen: function (tourId) {
      var email = getUserEmail();
      if (!email) return Promise.resolve(isSeenLocal(tourId));
      return apiCall('get_feature_tours_seen', { user_email: email }).then(function (data) {
        return !!(data && data.success && data.feature_tours_seen && data.feature_tours_seen[tourId]);
      }).catch(function () { return false; });
    },
  };
})();
